'use client'

import { useTopNav } from '@src/components/TopNavV3/TopNavContext'
import { TopNavDesktopBar } from '@src/components/TopNavV3/TopNavDesktop/TopNavDesktopBar'
import { TopNavDesktopSlidingPanel } from '@src/components/TopNavV3/TopNavDesktop/TopNavDesktopSlidingPanel'
import { cn } from '@src/utils/tailwind'

export const TopNavDesktop = () => {
  const { isExpanded, setExpanded } = useTopNav()

  return (
    <nav className="relative hidden lg:block" onMouseLeave={() => setExpanded(false)}>
      <TopNavDesktopBar />
      <TopNavDesktopSlidingPanel />
      {/* background blur effect */}
      <div
        className={cn('invisible fixed inset-0 z-30 transition-all', {
          'backdrop-blur-sm visible bg-bodi-black-text/80': isExpanded,
        })}
      ></div>
    </nav>
  )
}
